import { formControlClasses, inputClasses } from '@mui/material';
import { Stack } from '@mui/system';
import { memo } from 'react';

import { MultiSelectInput } from '@/modules/common/components/inputs/components/MultiSelectInput';
import { PropertiesLabel } from '@/modules/common/components/PropertiesLabel';
import { useReadSelectedAreas } from '@/modules/floorplanDesign/hooks';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';
import { useVehicleStore } from '@/modules/vehicles/store/useVehicleStore';
import { areasToFlatCollection } from '@/modules/floorplanDesign/helpers';
import { useAppStore } from '@/modules/app/store/useAppStore';
import { useVehicleType } from './useVehicleType';

const containerSx = {
  [`& .${formControlClasses.root} .${inputClasses.root}`]: {
    height: 'auto',
    padding: '4px 12px!important',
  },
};

const MultiVehicleTypeComponent = () => {
  const mode = useAppStore((state) => state.mode);
  const { allVehicles } = useVehicleStore();
  const selectedAreas = useReadSelectedAreas();
  const enabledVehicleTypeIds = useFloorplanDesignStore((state) => state.getVehicleTypeIds());

  const { displayValue, options, selectedOptions, onChange } = useVehicleType({
    selectedShapes: selectedAreas,
    enabledVehicles: allVehicles.getByIds(enabledVehicleTypeIds),
  });

  const areas = areasToFlatCollection(selectedAreas);
  const isDisabled = mode !== 'EDITABLE' || areas.length !== 1;

  return (
    <PropertiesLabel i18nkey='interface:properties.area.supported_vehicle.label'>
      <Stack sx={containerSx}>
        <MultiSelectInput
          disabled={isDisabled}
          options={options}
          selectedOptions={selectedOptions}
          onItemClick={onChange}
          displayValue={displayValue}
        />
      </Stack>
    </PropertiesLabel>
  );
};

export const MultiVehicleType = memo(MultiVehicleTypeComponent);
